module.exports.ConnectionStrings = Object.freeze({

    LoginServer: "https://c2custombuildingauthentication.azurewebsites.net",
    Services: "https://c2custombuildingcore.azurewebsites.net"

});